function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function SvgWorldWideWebSvg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#65B1FC"
    },
    d: "M481.901,339.399C420.099,468.999,325,497,256,497c-77.701,0-150.901-38.8-195.901-102.1 c-45.298-63.9-56.1-144.9-30-222.301L34.9,162.7C71.499,75.399,160.3,15,256,15c77.701,0,150.901,38.8,195.901,102.1 C497.199,181,508.001,262,481.901,339.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1689FC"
    },
    d: "M481.901,339.399C420.099,468.999,325,497,256,497V15c77.701,0,150.901,38.8,195.901,102.1 C497.199,181,508.001,262,481.901,339.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96EBE6"
    },
    d: "M464.2,108.399C416.201,41.199,338.5,0,256,0C153.1,0,58.9,64.6,20.2,159.699L15.099,170.2 C-12.446,254.076-1.721,333.523,47.8,403.599C95.799,470.799,173.5,512,256,512c101.7,0,194.7-63.1,234.6-156.101l4.499-9 C525.085,261.58,514.581,179.618,464.2,108.399z M72.4,386.199c-42.599-60-52.5-135.899-27.9-208.799l3.9-8.101 C72.7,111.099,121,66,178.599,44.399c-36.299,47.401-58.2,139.6-55.499,169.6c-0.3,0.901-0.601,1.8-0.601,3.001 c-7.8,100.499,15,197.5,57.9,251.8C137.5,453.199,99.401,424.3,72.4,386.199z M241,479.299c-10.499-3.6-21-11.499-30.901-22 C168.1,412,145,316.3,152.5,219.399V216.7c0-0.901,0.3-2.1,0.3-3.001c8.699-93.3,45.3-166.899,88.2-181V479.299z M271,478.999 v-446.3c46.199,15.3,84.901,100.3,89.399,201.7c4.2,93.6-19.199,181.5-59.7,224.101C291.099,468.399,281.201,475.699,271,478.999z  M467.5,334.6c-33.6,70.8-81,114.399-135.899,133.9c40.199-50.7,62.999-141.1,58.798-235.3c-3.6-79.801-26.1-148.599-58.799-190 c42.9,15.599,80.999,44.5,107.999,82.599C482.199,185.799,492.1,261.7,467.5,334.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00C8C8"
    },
    d: "M464.2,108.399C416.201,41.199,338.5,0,256,0v512c101.7,0,194.7-63.1,234.6-156.101l4.499-9 C525.085,261.58,514.581,179.618,464.2,108.399z M271,478.999v-446.3c46.199,15.3,84.901,100.3,89.399,201.7 c4.2,93.6-19.199,181.5-59.7,224.101C291.099,468.399,281.201,475.699,271,478.999z M467.5,334.6 c-33.6,70.8-81,114.399-135.899,133.9c40.199-50.7,62.999-141.1,58.798-235.3c-3.6-79.801-26.1-148.599-58.799-190 c42.9,15.599,80.999,44.5,107.999,82.599C482.199,185.799,492.1,261.7,467.5,334.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0053BF"
    },
    d: "M466,151H46c-24.901,0-46,20.099-46,45v120c0,24.899,21.099,45,46,45h420c24.901,0,46-20.101,46-45 V196C512,171.099,490.901,151,466,151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#05377F"
    },
    d: "M512,196v120c0,24.899-21.099,45-46,45H256V151h210C490.901,151,512,171.099,512,196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1F1FA"
    },
    d: "M329.5,232.599l-30,60C296.8,297.7,291.7,301,286,301s-10.8-3.3-13.5-8.401L256,259.6l-16.5,32.999 c-5.099,10.201-21.901,10.201-27.001,0l-30-60c-3.6-7.2-0.599-16.199,6.901-20.099c7.2-3.6,16.199-0.601,20.099,6.899L226,252.4 l16.5-33.001c2.701-5.099,8.101-7.8,13.5-7.8c5.399,0,10.8,2.701,13.5,7.8L286,252.4l16.5-33.001c3.9-7.5,12.9-10.499,20.099-6.899 C330.099,216.4,333.1,225.399,329.5,232.599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFE1FF"
    },
    d: "M436,301c-5.684,0-10.869-3.208-13.418-8.291L406,259.545l-16.582,33.164 c-5.098,10.166-21.738,10.166-26.836,0l-28.74-57.495c-1.86-2.285-3.062-5.112-3.267-8.218c-0.527-8.262,5.288-15.366,13.549-15.908 c6.27-0.146,12.598,2.813,15.293,8.203L376,252.455l16.582-33.164c5.098-10.166,21.738-10.166,26.836,0L436,252.455l16.582-33.164 c3.721-7.427,12.729-10.371,20.127-6.709c7.412,3.706,10.415,12.715,6.709,20.127l-30,60C446.869,297.792,441.684,301,436,301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E1F1FA"
    },
    d: "M166.967,211.029c-5.903-0.059-11.689,2.871-14.385,8.262L136,252.455l-16.582-33.164 c-5.403-10.769-21.492-10.688-26.836,0L76,252.455l-16.582-33.164c-3.721-7.427-12.744-10.371-20.127-6.709 c-7.412,3.706-10.415,12.715-6.709,20.127l30,60C65.131,297.792,70.316,301,76,301s10.869-3.208,13.418-8.291L106,259.545 l16.582,33.164C125.131,297.792,130.316,301,136,301s10.869-3.208,13.418-8.291l28.257-56.514c2.139-2.432,3.516-5.64,3.75-9.199 C181.952,218.734,175.229,211.571,166.967,211.029z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BFE1FF"
    },
    d: "M329.5,232.599l-30,60C296.8,297.7,291.7,301,286,301s-10.8-3.3-13.5-8.401L256,259.6v-48.001 c5.4,0,10.8,2.701,13.5,7.8L286,252.4l16.5-33.001c3.9-7.5,12.9-10.499,20.099-6.899C330.099,216.4,333.1,225.399,329.5,232.599z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorldWideWebSvg);
export default __webpack_public_path__ + "static/media/world-wide-web-svg.7d098832.svg";
export { ForwardRef as ReactComponent };